<template>
  <div>
    <div class="page-grid">
      <!--:column-type="['selection', 'index']"-->
        <div class="title-name">办理列表</div>

        <egrid class="egrid" :auto-height="true" stripe fit border highlight-current-row  v-loading="loading" element-loading-text="正在努力加载中..."
               :data="tableData" :columns="columns" :columns-schema="columnsSchema">
        </egrid>

        <span style="margin-top: -20px" class="title-name">流程图</span>
      <img :src="`${$api.myjob.procPic}/${flowId}`"/>

    </div>
  </div>

</template>
<script>
  import listMixins from '@/mixins/list'

  export default {
    mixins:[listMixins],
    name:'viewPregressStatus',
    props:{
      flowId:{
        type:String
      },
      canSetPerson:{
        type:Boolean,
        defaultValue:true,
      }
    },
    data(){
      return{
        // 以下为table相关
        params:{},
        columns:[
          { label: '流程环节',  prop: 'name', align: 'center', width: 'auto',  sortable: true, },
          { label: '审批人',  prop: 'assigneeName', align: 'center', width: 'auto',  sortable: true, },
          { label: '开始时间',  prop: 'startTime', align: 'center',width: 'auto', sortable: true, },
          { label: '结束时间',   prop: 'endTime',width: 'auto', align: 'center', sortable: true, },
          { label: '审批结果',  prop: 'result',width: 'auto' ,align: 'center', sortable: true, },
          { label: '审批意见',  prop: 'resultMessage',width: 'auto' ,align: 'center', sortable: true, },
        ],
        columnsSchema:{
          'resultMessage': {
            propsHandler({col, row}) {
              return {row: row[col.prop]}
            },
            component: 'popShow'
          },},

      }
    },
    methods:{

      cancel(){
        this.$emit('cancel')
      }
    },
    mounted() {
      console.log('mounted delegation')
      /*this.$fetchData(this.$api.myjob.dueList+'/'+this.row.processInstanceId).then(res=>{
          console.log('流程进度的list ',res)
      })*/

      let self=this;
      // 获取表格数据
      self.loading = true
      self.state = false
      self.$fetchData(self.$api.myjob.dueList+'/'+self.flowId, self.params)
        .then(res => {
          self.loading = false
          if (res.totalRows != undefined) {
          }
          self.tableData = res
          self.state = true
        }).catch(error => {
        self.loading = false
        self.state = false
      })
    },
  }

</script>
